import { render, staticRenderFns } from "./DaysOfWeek.vue?vue&type=template&id=71aefc6b&scoped=true&"
import script from "./DaysOfWeek.vue?vue&type=script&lang=js&"
export * from "./DaysOfWeek.vue?vue&type=script&lang=js&"
import style0 from "./DaysOfWeek.vue?vue&type=style&index=0&id=71aefc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aefc6b",
  null
  
)

export default component.exports